module.exports = __webpack_public_path__ + "img/history_timeline_11.1b3e676d.png";